import type { MouseEvent } from "react";
import type { AppPath, Placement } from "../workspaceTypes";

/** Where a modified click on a link of this app opens it, as a browser does with its tabs (Q2). */
function placementOfClick(event: MouseEvent): Placement | null {
  if (event.button === 1 || (event.button === 0 && (event.ctrlKey || event.metaKey))) return "newTab";
  if (event.button === 0 && event.altKey) return "beside";
  return null;
}

function appLinkOf(event: MouseEvent): AppPath | null {
  const anchor = event.target instanceof Element ? event.target.closest("a[href]") : null;
  if (!(anchor instanceof HTMLAnchorElement) || anchor.target !== "" || anchor.hasAttribute("download")) return null;
  const url = new URL(anchor.href);
  return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null;
}

/**
 * A capture handler for `onClickCapture` and `onAuxClickCapture`: Ctrl+click or a middle click
 * on a link opens it in a new tab, Alt+click beside; a plain click stays in its tab (F90, Q2).
 */
export function modifiedLinkClick(open: (route: AppPath, placement: Placement) => void): (event: MouseEvent) => void {
  return (event) => {
    const placement = placementOfClick(event);
    const route = placement === null ? null : appLinkOf(event);
    if (placement === null || route === null) return;
    event.preventDefault();
    event.stopPropagation();
    open(route, placement);
  };
}
